<template>
  <!-- Connect with people -->
  <section class="features-wrapper has-text-centered">
    <div class="features">
      <h2 class="h2 mb-4">
        {{ $t('page.whatIsLiffery.allFeatures.title') }}
      </h2>
      <div class="content">
        <p>
          {{ $t('page.whatIsLiffery.allFeatures.text1') }}
        </p>
        <div class="you-tube mt-6 mb-6">
          <m-you-tube
              :vid-id="$t('page.whatIsLiffery.allFeatures.youtubeRef')"
              auto-play="0"
          />
        </div>

        <div class="is-flex is-justify-content-center is-align-items-center">
          <button class="button is-primary lfr-button mr-4" @click="loginPrompt">
            {{ $t('page.whatIsLiffery.opener.cta') }}
          </button>

          <a-link link="https://play.google.com/store/apps/details?id=com.liffery.www" class="mr-4">
            <img v-if="!isIosApp" src="@/assets/landing-pages/new/mobile-play-store-badge-green.svg"
                 alt="Liffery Google Play Store"/>
          </a-link>

          <a-link link="https://apps.apple.com/de/app/liffery/id1577076705?l=en">
            <img src="@/assets/landing-pages/new/mobile-app-store-badge-green.svg" alt="Liffery App Store"/>
          </a-link>
        </div>
      </div>
    </div>
  </section>
</template>


<style scoped lang="scss">
.you-tube {
  border-top: 1px solid $primary;
  border-bottom: 1px solid $primary;
}

.features-wrapper {
  position: relative;
  padding-top: 3.5rem;
  padding-bottom: 1rem;
  color: $black;
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);

  &::after {
    content: "";
    position: absolute;
    top: -3px;
    right: 0;
    left: 0;
    height: 13.7rem;
    background: linear-gradient(180deg, rgba(81, 156, 123, 0.1) 0%, rgba(196, 196, 196, 0) 100%, rgba(255, 255, 255, 0) 100%);
  }
}

.features {
  max-width: 52.95rem;
  margin: 2rem auto 2rem;
  line-height: 20px !important;

  @media screen and (max-width: $tablet) {
    padding: 0 2rem;
  }

  .content {
    text-align: left;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import MYouTube from '@/components/molecules/video/MYouTube.vue';
import ALink from '@/components/atoms/link/ALink.vue';
import isIosApp from '@/utils/isIosApp';
import { AuthenticationStore } from '@/store';

@Component({
  components: { ALink, MYouTube }
})
export default class OForPeopleFeatures extends Vue {
  isIosApp = isIosApp();

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_LOGIN({ state: true });
  }
}
</script>
